import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { TaskActionHandler } from '../contracts/task-action.contract';
import { Task, TaskType } from '../models/task.interface';
import * as TaskActions from '../store/task.actions';

@Injectable()
export class OrphanedOfferingActionHandler implements TaskActionHandler<TaskType.OrphanedOffering> {
  private readonly router = inject(Router);
  private readonly store = inject(Store);

  readonly type = TaskType.OrphanedOffering;

  execute(task: Task<TaskType.OrphanedOffering>): void {
    this.store.dispatch(TaskActions.startTask({ task }));
    this.router.navigate(['/tasks', task.id]);
  }
}
